export class AddEditComment{
    comment:string;
    dateTime:any
}